import './ModalWrapper.scss';
import React, { ReactNode } from 'react';

export const ModalWrapper = ({ children, hidden, onClose }: { children: ReactNode, hidden: boolean, onClose: () => void }) => {
  return (
    <div className={`modal-component ${hidden ? 'hidden' : ''}`}>
      <div className="modal-background" onClick={() => onClose()}></div>
      <div className="modal-content">
        { children }
      </div>
    </div>
  );
}
